import { LoadingContext, ModalContext } from "../context/contextProvider";
import { ThemeColorsEnum, TruckColumnsEnum } from "../constants/enums";

import { AppRoutes } from "../constants/appRoutes";
import DropdownSelect from "../components/forms/DropdownSelect";
import Services from "../services/services";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

const useTrucksDataTable = (onDeleted = () => {}) => {
  const navigate = useNavigate();

  const { setLoading } = useContext(LoadingContext);
  const { showConfirmation } = useContext(ModalContext);

  const handleDelete = async (truck) => {
    setLoading(true);
    const response = await Services.api.trucks.delete(truck.id);
    setLoading(false);

    if (!response.ok)
      return Services.utility.toast(
        "Could not delete the truck",
        ThemeColorsEnum.error
      );

    Services.utility.toast("Truck deleted", ThemeColorsEnum.success);
    onDeleted(truck);
  };

  const menuItems = (row) => [
    // Edit
    {
      // href: AppRoutes.products_edit.replace(":id", row.id),
      onClick: () =>
        navigate(AppRoutes.trucks_edit.replace(":id", row.id), {
          state: { product: row },
        }),
      title: "Edit",
    },
    { type: "divider" },
    // Delete
    {
      className: "text-danger",
      onClick: () => {
        showConfirmation(
          "Confirmation",
          "Do you really want to delete this truck?",
          [
            {
              color: ThemeColorsEnum.quaternary,
              title: "Cancel",
            },
            {
              color: ThemeColorsEnum.danger,
              onClick: () => handleDelete(row),
              title: "Delete",
            },
          ]
        );
      },
      title: "Delete",
    },
  ];

  const columns = [
    {
      header: {
        className: "col-menu",
        id: TruckColumnsEnum.actionButton,
        name: "id",
      },
      cell: (row) => (
        <DropdownSelect
          color={ThemeColorsEnum.quaternary}
          fixedTitle
          items={menuItems(row)}
          itemLabelProperty="title"
          itemValueProperty="title"
          size="sm"
          style={{ width: "auto" }}
          title={<i className="fa fa-bars" />}
          // title={<MenuIcon />}
        />
      ),
      dataTitle: "Menu",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.name,
        name: "name",
        text: "Name",
        sortable: true,
      },
      cell: (row) => row.name,
      dataTitle: "Name",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.products,
        name: "productsListFormatted",
        text: "Products",
        sortable: true,
      },
      cell: (row) =>
        row?.productsListFormatted?.map((productInfo, index) => (
          <div key={productInfo + index}>{productInfo}</div>
        )),
      dataTitle: "Products",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.year,
        name: "year",
        text: "Year",
        sortable: true,
      },
      cell: (row) => row.year,
      dataTitle: "Year",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.make,
        name: "make",
        text: "Make",
        sortable: true,
      },
      cell: (row) => row.make,
      dataTitle: "Make",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.model,
        name: "model",
        text: "Model",
        sortable: true,
      },
      cell: (row) => row.model,
      dataTitle: "Model",
      className: "nowrap",
    },
    {
      header: {
        id: TruckColumnsEnum.notes,
        name: "notes",
        text: "Notes",
        sortable: true,
      },
      cell: (row) => row.notes,
      dataTitle: "Notes",
      className: "nowrap",
    },
  ];

  return { columns };
};

export default useTrucksDataTable;
